import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ptTranslation from './local/pt/translation.json';
import enTranslation from './local/en/translation.json';
import deTranslation from './local/de/translation.json';
import ptArticle from './local/pt/article.json';
import enArticle from './local/en/article.json';
import deArticle from './local/de/article.json';

const resources = {
  pt: {
    translation: ptTranslation,
    article: ptArticle,
  },
  en: {
    translation: enTranslation,
    article: enArticle,
  },
  de: {
    translation: deTranslation,
    article: deArticle,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt',
    detection: {
      order: ['path', 'navigator', 'htmlTag'],
      lookupFromPathIndex: 0,
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;